<template>
  <v-expansion-panel class="pt-2">
    <v-expansion-panel-header class="expansion--panel">
      <template v-slot:default="{ open }">
        <v-row no-gutters>
          <v-col cols="4"><v-icon color="white">mdi-history</v-icon> {{ $t("message.orders.history") }}</v-col>
          <v-col cols="8" class="text-right pr-6">
            <v-fade-transition leave-absolute>
              <span v-if="!open" key="0"
                >{{ $t("message.common.total") }}: {{ total }}</span
              >
            </v-fade-transition>
          </v-col>
        </v-row>
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="pt-2">
      <data-list :payload="modelObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination">
        <v-container fluid slot="filterForm" class="pt-0">
         <v-row justify="center" align="center">
            <v-col cols="6" lg="6">
              <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="getListHandler" @click:append="getListHandler" outlined dense v-model="search" :label="$t('message.common.search')" class="text-xs-right search-hint-padding" id="searchbtn"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </data-list>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import DataList from '../../components/DataList.vue'
import { mapState } from 'vuex'
import CONSTANTS from '@/utils/warehouse.json'
export default {
  components: {
    DataList
  },
  props: {
    model: {
      type: Object
    }
  },
  data () {
    return {
      MODULE_URL: 'productbatchhistories',
      modelObj: {
        isHeader: true,
        isHideAdd: false,
        hasFilters: true,
        selection: [],
        editProp: 'ordernumber',
        editURL: (item) => this.navigateToOrder(item),
        list: [],
        loading: true,
        page: 1
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(
        this.$store.state.BATCHES_INDEX
      )
        ? this.$store.state.BATCHES_INDEX
        : {
          sortBy: ['date'],
          itemsPerPage: 25,
          sortDesc: [true],
          search: ''
        },
      filterObj: {
        productid: this.model.id
      },
      search: ''
    }
  },
  created () {
    this.getListHandler()
  },
  computed: {
    ...mapState(['BATCHES_INDEX']),
    headers () {
      return [
        {
          text: this.$t('message.whOrder.batch'),
          value: 'batchnumber',
          width: '15%'
        },
        {
          text: `${this.$t('message.layout.order')}`,
          value: 'ordernumber',
          width: '15%'
        },
        {
          text: `${this.$t('message.orders.customerOrder')}`,
          value: 'customername',
          width: '15%'
        },
        {
          text: `${this.$t('message.layout.warehouse')}`,
          value: 'warehousename',
          width: '15%'
        },
        {
          text: `${this.$t('message.deviations.location')}`,
          value: 'locationname',
          width: '10%'
        },
        {
          text: `${this.$t('message.stock.costPrice')}`,
          value: 'productcostprice',
          align: 'right',
          width: '10%'
        },
        {
          text: `${this.$t('message.order.qty')}`,
          value: 'qty',
          align: 'right',
          width: '15%'
        },
        {
          text: `${this.$t('message.order.date')}`,
          value: 'date',
          width: '15%'
        }
      ]
    }
  },
  watch: {
    pagination (val) {
      let model = { type: 'BATCHES_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    },
    search: function (newValue, oldValue) {
      let data = { type: 'F_WH_PRODUCT_BATCHES', data: { search: newValue } }
      this.$store.commit('rememberFilter', data)
      if (!newValue) this.getListHandler()
    }/* ,
    filterObj: {
      handler (newValue, oldValue) {
        if (newValue) {
          let data = { type: 'F_WH_ORDERS', data: { filter: newValue } }
          this.$store.commit('rememberFilter', data)
          this.getListHandler()
        }
      },
      deep: true
    } */
  },
  mounted () {
    if (!this.$formatter.isEmptyObject(this.$store.state.F_WH_PRODUCT_BATCHES)) {
      let searchObj = this.$formatter.cloneVariable(this.$store.state.F_WH_PRODUCT_BATCHES)
      this.search = searchObj.search
    }
  },
  methods: {
    getListHandler () {
      this.modelObj.loading = true
      this.modelObj.module = this.MODULE_URL
      let { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let pageVal = page || 1
      let model = { ...this.filterObj, search: this.search, sortby: sortBy[0], rowsperpage: itemsPerPage, page: pageVal, descending: sortDesc[0] }
      this.$_executeApi('post', `${this.MODULE_URL}/paginate_filter`, model)
        .then((response) => {
          let batchList = response.data.items
          // let transformData = { number: { list: ['qty', 'productcostprice'], format: 'replaceDotWithComma' },
          //   date: { list: ['date'], from: 'DD-MM-YYYY', to: 'DD.MM.YYYY' } }
          // let model = this.$_formatListModel(batchList, transformData)

          batchList.map(x => {
            x.qty = this.$formatter.replaceDotWithComma(x.qty)
            x.productcostprice = this.$formatter.replaceDotWithComma(x.productcostprice)
            x.date = this.$formatter.formatDate(x.date, 'DD-MM-YYYY', 'DD.MM.YYYY')
            // if (x.type === 'customer') x.qty = `-${x.qty}`
            return x
          })

          this.modelObj.loading = false
          this.modelObj.list = batchList
          this.total = response.data.total
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.modelObj.page = 1
          }
        })
    },
    navigateToOrder (item) {
      if (item.type === CONSTANTS.WAREHOUSE) {
        if (item.warehouseorder_type === CONSTANTS.SUPPLIER) { return `/w_h/order/supplierorder/actions/${item.orderid}` } else if (item.warehouseorder_type === CONSTANTS.ADJUSTMENT) { return `/w_h/order/adjustmentorder/actions/${item.orderid}` } else if (item.warehouseorder_type === CONSTANTS.RETURN) { return `/w_h/order/returnorder/actions/${item.orderid}` } else if (item.warehouseorder_type === CONSTANTS.TRANSFER) { return `/w_h/order/transferorder/actions/${item.orderid}` }
      } else if (item.type === CONSTANTS.CUSTOMER) {
        return `/orders/edit/${item.orderid}/materials`
      }
    }
  }
}
</script>
